"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
exports.__esModule = true;
exports.configureRootFlexApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQuery_1 = require("./baseQuery");
var bill_1 = require("./bill");
var biller_1 = require("./biller");
var wallet_1 = require("./wallet");
var account_1 = require("./account");
var payment_1 = require("./payment");
var developer_1 = require("./developer");
var verification_1 = require("./verification");
__exportStar(require("./utils"), exports);
__exportStar(require("./types"), exports);
__exportStar(require("./account/account-hook-factory"), exports);
function configureRootFlexApi(args) {
    var rootApi = (0, react_1.createApi)({
        baseQuery: (0, baseQuery_1.getFlexBaseQuery)(args),
        endpoints: function () { return ({}); }
    });
    return {
        rootApi: rootApi,
        developer: (0, developer_1.setupDeveloperEndpoints)(rootApi),
        bill: (0, bill_1.setupBillEndpoints)(rootApi),
        biller: (0, biller_1.setupBillerEndpoints)(rootApi),
        wallet: (0, wallet_1.setupWalletEndpoints)(rootApi),
        account: (0, account_1.setupAccountEndpoints)(rootApi),
        payment: (0, payment_1.setupPaymentEndpoints)(rootApi),
        verification: (0, verification_1.setupVerificationEndpoints)(rootApi)
    };
}
exports.configureRootFlexApi = configureRootFlexApi;
